import './widget.css';

import { Components } from '@ionic/core';
import { IonLabel, IonText } from '@ionic/react';
import { DOMAttributes, HTMLAttributes, ReactElement, useMemo } from 'react';
import { FieldLocked } from '../../../../../components/ui/field-locked';
import { formatYupError } from '../../util/yup';

interface WidgetLabelProps {
  label?: string;
  subtitle?: string;
  subtitleColor?: string;
  description?: string;
  showDescription?: boolean;
  ionLabelProps?: Partial<Components.IonLabel> &
    Partial<HTMLAttributes<HTMLIonItemElement>> &
    Partial<DOMAttributes<HTMLIonItemElement>>;
  error?: string;
  forceDisable?: boolean;
}

const WidgetLabel = (props: WidgetLabelProps): ReactElement => {
  const {
    label,
    subtitle,
    subtitleColor,
    description,
    showDescription = false,
    error,
    forceDisable,
    ionLabelProps,
  } = props;

  const { className: ionLabelClassName, ...restIonLabelProps } =
    ionLabelProps ?? {};
  const className = useMemo(() => {
    const classes = ['widget-label', 'ion-text-wrap'];

    if (forceDisable) {
      classes.push('item-interactive-disabled');
    }

    if (ionLabelClassName) {
      classes.push(...ionLabelClassName.split(' '));
    }

    return classes.join(' ');
  }, [forceDisable, ionLabelClassName]);

  return (
    <>
      <IonLabel className={className} {...restIonLabelProps}>
        <div>
          {label}
          <FieldLocked show={forceDisable ?? false} />
        </div>
        {showDescription && (
          <p>
            <IonText style={{ fontWeight: 'initial', fontSize: 'small' }}>
              {description}
            </IonText>
          </p>
        )}
        <p style={{ width: '100%' }}>
          <IonText color="danger">{formatYupError(error)}</IonText>
        </p>
        <IonText
          style={{ fontWeight: 'initial', fontSize: 'small' }}
          color={subtitleColor ?? 'primary'}
        >
          <p>{subtitle}</p>
        </IonText>
      </IonLabel>
    </>
  );
};

export { WidgetLabel };
